module.exports = __webpack_public_path__ + "static/media/August_2026_1.2d26952b.webp";